<template>
  <div>
    <el-row type="flex" justify="end" class="title-bar">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-row>
      <el-table-wrapper v-loading="isLoading" border ref="interfaceTable" :data="tableDatas" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" :show-overflow-tooltip="true"
      :pagination="true" :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable">
        <template slot-scope="scope" slot="userate-in-slot">
          <w-rsc-perf-event-progress-bar v-if="!isNil(scope.row['TRAFFIC/TRAFFIC_USERATE_IN'])" :perfRecords="scope.row" perfKey="TRAFFIC/TRAFFIC_USERATE_IN" />
          <span v-else>{{ EMPTY_TEXT }}</span>
        </template>
        <template slot-scope="scope" slot="userate-out-slot">
          <w-rsc-perf-event-progress-bar v-if="!isNil(scope.row['TRAFFIC/TRAFFIC_USERATE_OUT'])" :perfRecords="scope.row" perfKey="TRAFFIC/TRAFFIC_USERATE_OUT" />
          <span v-else>{{ EMPTY_TEXT }}</span>
        </template>
        <template slot-scope="scope" slot="discard-in-slot">
          <w-rsc-perf-event-progress-bar v-if="!isNil(scope.row['TRAFFIC_ERROR/TRAFFIC_DISCARD_IN'])" :perfRecords="scope.row" perfKey="TRAFFIC_ERROR/TRAFFIC_DISCARD_IN" />
          <span v-else>{{ EMPTY_TEXT }}</span>
        </template>
        <template slot-scope="scope" slot="discard-out-slot">
          <w-rsc-perf-event-progress-bar v-if="!isNil(scope.row['TRAFFIC_ERROR/TRAFFIC_DISCARD_OUT'])" :perfRecords="scope.row" perfKey="TRAFFIC_ERROR/TRAFFIC_DISCARD_OUT" />
          <span v-else>{{ EMPTY_TEXT }}</span>
        </template>
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEmpty } from 'lodash';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValueForInterfaceSpeed } from '@/utils/number';
import commonAPI from '@/api/performance/common';
import WRscPerfEventProgressBar from '@/components/progressbar/RscPerfEventProgressBar';

export default {
  name: 'WInterfacePerfTable',
  components: { WRscPerfEventProgressBar },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      isLoading: false,
      tableDatas: [],
      columnDefault,
      tableTotal: 0,
      showSearchTool: false,
      columns: [
        { prop: 'parentObjName', remoteProp: 'ni.parentObjName', label: '장비명', headerAlign: 'center', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'netinterfaceName', remoteProp: 'ni.netinterfaceName', label: '인터페이스명', headerAlign: 'center', searchable: true, sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ipaddress', label: 'IP', headerAlign: 'center', searchable: true, sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'netinterfaceAlias', remoteProp: 'ni.netinterfaceAlias', label: '별칭', headerAlign: 'center', searchable: true, sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { label: 'bps',
          headerAlign: 'center',
          childColumns: [
            { prop: 'TRAFFIC/TRAFFIC_BPS_IN', sortable: true, label: 'IN', headerAlign: 'center', width: 90, formatter: this.convertKValue },
            { prop: 'TRAFFIC/TRAFFIC_BPS_OUT', sortable: true, label: 'OUT', align: 'center', width: 90, formatter: this.convertKValue },
          ],
        },
        { label: 'pps',
          headerAlign: 'center',
          childColumns: [
            { prop: 'TRAFFIC/TRAFFIC_PPS_IN', sortable: true, label: 'IN', headerAlign: 'center', width: 90, formatter: this.convertKValue },
            { prop: 'TRAFFIC/TRAFFIC_PPS_OUT', sortable: true, label: 'OUT', headerAlign: 'center', width: 90, formatter: this.convertKValue },
          ],
        },
        { label: '이용률',
          headerAlign: 'center',
          childColumns: [
            { prop: 'TRAFFIC/TRAFFIC_USERATE_IN', sortable: true, label: 'IN', align: 'center', width: 100, scopedSlot: 'userate-in-slot' },
            { prop: 'TRAFFIC/TRAFFIC_USERATE_OUT', sortable: true, label: 'OUT', align: 'center', width: 100, scopedSlot: 'userate-out-slot' },
          ],
        },
        { label: '기각률',
          headerAlign: 'center',
          childColumns: [
            { prop: 'TRAFFIC_ERROR/TRAFFIC_DISCARD_IN', sortable: true, label: 'IN', align: 'center', width: 100, scopedSlot: 'discard-in-slot' },
            { prop: 'TRAFFIC_ERROR/TRAFFIC_DISCARD_OUT', sortable: true, label: 'OUT', align: 'center', width: 100, scopedSlot: 'discard-out-slot' },
          ],
        },
        { prop: 'TRAFFIC_ERROR/TRAFFIC_CRC_IN', sortable: true, label: 'CRC', width: 90, formatter: this.convertKValue, headerAlign: 'center' },
        { prop: 'TRAFFIC_ERROR/TRAFFIC_COLLISION_OUT', sortable: true, label: 'COLLISION', width: 90, formatter: this.convertKValue, headerAlign: 'center' },
      ],
      EMPTY_TEXT,
    };
  },
  computed: mapGetters(['selectedNode', 'selectedObjDefineIds', 'selectedObjDefineIdsForPhysical']),
  watch: {
    selectedNode: {
      handler() {
        if (this.$refs.interfaceTable === undefined) {
          this.$nextTick(() => {
            this.$refs.interfaceTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
            this.loadStore();
          });
        } else {
          this.$refs.interfaceTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
          this.loadStore();
        }
      },
      immediate: true,
    },
    selectedObjDefineIdsForPhysical: {
      handler() {
        this.loadStore();
      },
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    isNil,
    loadStore() {
      if (this.active) {
        this.isLoading = true;
        const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
        const tableParams = this.$refs.interfaceTable.getParameter();
        const params = {
          managegroupIds: this.selectedNode.childManagegroupIds,
          managetypeId: 'NMS',
          objDefineId: this.selectedObjDefineIds[0],
          treeType,
          ...tableParams,
        };
        if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
          params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
        }
        commonAPI
          .getPerformanceGroupList(params)
          .then((result) => {
            if (result.data.success === true) {
              this.tableDatas = result.data.data;
              this.tableTotal = result.data.total;
            }
          }).catch(() => {}).finally(() => {
            this.isLoading = false;
          });
      }
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [getStringtoNumber String형 Number형으로 변경]
     * @author {Yang}
     */
    getStringtoNumber(value) {
      return Number(value);
    },
    /**
     * [테이블 컬럼 포멧]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    convertKValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValueForInterfaceSpeed(value);
    },
    onChangeTable() {
      this.loadStore();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/group/perfinfo/components/InterfacePerfTable.vue